import { animate, group, query, style, transition, trigger } from '@angular/animations';

import {
  AnimationTransition,
  applyFadeInAnimation,
  applyFadeInTranslateAnimation,
  applyFadeOutTranslateAnimation,
  getAnimationString,
} from '../../core/animations';

export const VendorDetailsPageAnimations = [
  trigger('animatedContent', [transition(AnimationTransition.VoidToAny, applyFadeInAnimation({ duration: 500, delay: 300 }))]),
  trigger('animatedFooter', [
    transition(AnimationTransition.VoidToAny, applyFadeInTranslateAnimation({ duration: 500, distance: '100%' })),
    transition(AnimationTransition.AnyToVoid, applyFadeOutTranslateAnimation({ duration: 500, distance: '100%' })),
  ]),
  trigger('animatedChatButtonContent', [
    transition(
      AnimationTransition.VoidToAny,
      group([
        query('.animated-text-container', [
          style({ width: 0, 'padding-left': 0, 'padding-right': 0, 'margin-left': 0, 'margin-right': 0 }),
          animate(getAnimationString({ duration: 300 })),
        ]),
        query('.animated-text', applyFadeInTranslateAnimation({ duration: 300, delay: 240, distance: '10px' })),
      ]),
    ),
    transition(
      AnimationTransition.AnyToVoid,
      group([
        query('.animated-text-container', [
          style({ width: '*', 'padding-left': '*', 'padding-right': '*', 'margin-left': '*', 'margin-right': '*' }),
          animate(
            getAnimationString({ duration: 300 }),
            style({ width: 0, 'padding-left': 0, 'padding-right': 0, 'margin-left': 0, 'margin-right': 0 }),
          ),
        ]),
        query('.animated-text', applyFadeOutTranslateAnimation({ duration: 300, distance: '10px' })),
      ]),
    ),
  ]),
  trigger('animatedTabBarBackground', [transition(AnimationTransition.VoidToAny, applyFadeInAnimation({ duration: 400 }))]),
];
